import { render, staticRenderFns } from "./gift_bag.vue?vue&type=template&id=8000d52e&scoped=true"
import script from "./gift_bag.vue?vue&type=script&lang=js"
export * from "./gift_bag.vue?vue&type=script&lang=js"
import style0 from "./gift_bag.vue?vue&type=style&index=0&id=8000d52e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8000d52e",
  null
  
)

export default component.exports